module.exports = __webpack_public_path__ + "img/tent-icon.31b10a25.jpg";